import { useCallback } from 'react';

import { DateTime } from 'luxon';

import { FormField } from 'src/common/FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';
import { useIsSelectedTripInThePast } from 'src/features/add-trip/useIsSelectedTripInThePast';

import { useCanCreateTripInThePast } from './useCanCreateTripInThePast';
import { validateTripDate } from './validateTripDate';
import { validateTripDateOnEditingTripInThePast } from './validateTripDateOnEditingTripInThePast';

export function TripDateContextField({ fieldPath }: { fieldPath: string }) {
  const isSelectedTripInThePast = useIsSelectedTripInThePast();
  const canCreateTripInThePast = useCanCreateTripInThePast();
  const validate = useTripDateValidation();
  return (
    <FormFieldController
      name={`${fieldPath}.date`}
      rules={{
        validate,
      }}
    >
      {({ field, fieldState }) => {
        return (
          <FormField
            label="Trip Date *"
            error={fieldState.error?.message?.toString()}
            inputProps={{
              id: `${fieldPath}.date`,
              ...field,
              onChange: field.onChange,
              min: canCreateTripInThePast
                ? undefined
                : DateTime.local().toISODate(),
              disabled: isSelectedTripInThePast,
            }}
            {...field}
            type="date"
          />
        );
      }}
    </FormFieldController>
  );
}

function useTripDateValidation() {
  const isSelectedTripInThePast = useIsSelectedTripInThePast();
  const canCreateTripInThePast = useCanCreateTripInThePast();
  const validate = useCallback(
    (value: any) => {
      if (isSelectedTripInThePast) {
        return validateTripDateOnEditingTripInThePast(value);
      }

      if (canCreateTripInThePast) {
        return !!value || 'Trip Date is required';
      }
      return validateTripDate(value);
    },
    [canCreateTripInThePast, isSelectedTripInThePast]
  );

  return validate;
}
